/**
 * Automatically generated by migrate-from-absolute-to-static-asset.ts */
import navigation_Up_2 from 'assets/media/svg/icons/Navigation/Up-2.svg';
import SVG from 'react-inlinesvg';
export function ScrollTop() {
  return (
    <div className="scrolltop" id="kt_scrolltop">
      <span className="svg-icon">
        <SVG src={navigation_Up_2}></SVG>
      </span>{' '}
    </div>
  );
}
